<div class="balance-widget">
    <ng-content></ng-content>
</div>
